<ng-container *ngIf="data">
  <div class="d-flex p-0 pb-1 m-0 align-items-center" [ngStyle]="{ 'justify-content': align }">
    <span class="fs-6 pe-2 fw-semibold"> {{ title }} </span>

    <button *ngIf="obbligoDetails$ | async as details" [disablePopover]="!details?.riferimentoNormativo"
      [ngbPopover]="popoverContent" [placement]="'bottom-right'" triggers="manual" #p1="ngbPopover"
      class="btn btn-link btn-sm p-0 bg-transparent" (click)="togglePopover(p1, details?.riferimentoNormativo)">
      <div class="avatar size-lg col-auto bg-primary" style="background-color: #007bc6 !important">
        <i [ngClass]="iconUrl" class="text-white"></i>
      </div>
    </button>

  </div>
</ng-container>

<ng-template #popoverContent let-description="description">
  <span class="popover-body" [innerHTML]="description"></span>
</ng-template>